import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PromoBar from './PromoBar';
import Header from './Header';
import DeferredSection from './DeferredSection';
import { useCart } from '../context/CartContext';

const CartDrawer = lazy(() => import('./CartDrawer'));
const Footer = lazy(() => import('./Footer'));
// const PromoPopup = lazy(() => import('./PromoPopup')); // disabled 2026-08-10 (moved to hero slide 2)
const SubscribePopup = lazy(() => import('./SubscribePopup'));
const CookieBanner = lazy(() => import('./CookieBanner'));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const didMountRef = React.useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return undefined;
    }

    const raf = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    });

    return () => window.cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
};

const Layout = () => {
  const { open } = useCart();
  const [canLoadDrawer, setCanLoadDrawer] = useState(false);

  useEffect(() => {
    if (open) setCanLoadDrawer(true);
  }, [open]);

  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <ScrollToTop />
      <PromoBar />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <DeferredSection rootMargin="480px 0px" minHeight={340}>
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </DeferredSection>
      {canLoadDrawer ? (
        <Suspense fallback={null}>
          <CartDrawer />
        </Suspense>
      ) : null}
      {/* Entry promo popup disabled 2026-08-10 at client request — the free-delivery
          promo now lives as hero carousel slide 2 instead. Re-enable by uncommenting. */}
      {/* <Suspense fallback={null}><PromoPopup /></Suspense> */}
      {/* Збір пошти для розсилки — окремий скромний компонент, не воскресіння
          промо-вікна вище: картка в кутку через 25 с або на намір піти. */}
      <Suspense fallback={null}><SubscribePopup /></Suspense>
      {/* Повідомлення про cookie. Тільки публічні сторінки: в адмінці свій
          Layout, і показувати згоду власниці магазину сенсу немає. */}
      <Suspense fallback={null}><CookieBanner /></Suspense>
    </div>
  );
};

export default Layout;
